export const leaveClan = async (clanId, token) => {
    try {
        const response = await fetch(`https://blue-moon-app-backend.vercel.app/clan/${clanId}/leave`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });
        if (response.ok) {
            const data = await response.json();
            const clanData = data.clan;
            return clanData;
        } else {
            throw new Error('Failed to fetch user data');
        }
    } catch (error) {
        console.error('Error:', error);
    }
};